import React, { useState } from "react";

//UI Material
import { Avatar, Button, Chip, Grid, Stack, Typography } from "@mui/material";

//Material Icons
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";

export default function OrderSummary({ data }) {
  // ==========>Component States<==========
  const [showDetails, setShowDetails] = useState(false);

  //Dates
  const dueDate = new Date(data.dueDate);
  const createdAt = new Date(data.createdAt);
  const canceledAt = new Date(data.canceledAt);

  //Date formatting
  const options = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };

  // ==========>Component<==========
  return (
    <Grid container spacing={1} justifyContent="flex-start" textAlign="left">
      <Grid item xs={12}>
        <Stack
          justifyContent="flex-start"
          alignItems="flex-start"
          textAlign="left"
        >
          <Typography variant="body2" fontWeight="bold">
            Nombre del cliente
          </Typography>
          <Typography variant="h6">{data.client}</Typography>
        </Stack>
      </Grid>
      <Grid item xs={12}>
        <Chip
          label={<Typography variant="body2">{data.productName}</Typography>}
          avatar={
            <Avatar sx={{ backgroundColor: "white" }}>
              <Typography variant="body2" fontWeight="bold">
                {data.products.length}
              </Typography>
            </Avatar>
          }
          variant="outlined"
        />
      </Grid>
      <Grid item xs={12}>
        <Stack
          justifyContent="flex-start"
          alignItems="flex-start"
          textAlign="left"
        >
          <Typography variant="body2" fontWeight="bold">
            Fecha de entrega
          </Typography>
          <Typography variant="body2">
            {dueDate.toLocaleDateString("es-ES", options)}
          </Typography>
        </Stack>
      </Grid>

      <Grid item xs={12}>
        <Button
          sx={{ fontSize: "10px" }}
          color="secondary"
          size="small"
          startIcon={!showDetails ? <KeyboardArrowDown /> : <KeyboardArrowUp />}
          onClick={() => setShowDetails(!showDetails)}
        >
          {showDetails ? "ver menos información" : "ver más información"}
        </Button>
      </Grid>

      {showDetails && (
        <Grid item xs={12}>
          <Grid container>
            <Grid item xs={12}>
              <Stack
                justifyContent="flex-start"
                alignItems="flex-start"
                textAlign="left"
              >
                <Typography variant="body2" fontWeight="bold">
                  Fecha de creación
                </Typography>
                <Typography variant="body2">
                  {createdAt.toLocaleDateString("es-ES", options)}
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={12}>
              <Stack
                justifyContent="flex-start"
                alignItems="flex-start"
                textAlign="left"
              >
                <Typography variant="body2" fontWeight="bold">
                  Usuario generador
                </Typography>
                <Typography variant="body2">{data.createdBy}</Typography>
              </Stack>
            </Grid>

            {data.canceledBy && (
              <Grid item xs={12}>
                <Stack
                  justifyContent="flex-start"
                  alignItems="flex-start"
                  textAlign="left"
                >
                  <Typography variant="body2" fontWeight="bold">
                    Orden cancelada por
                  </Typography>
                  <Typography variant="body2">{data.canceledBy}</Typography>
                </Stack>
              </Grid>
            )}
            {data.canceledReason && (
              <Grid item xs={12}>
                <Stack
                  justifyContent="flex-start"
                  alignItems="flex-start"
                  textAlign="left"
                >
                  <Typography variant="body2" fontWeight="bold">
                    Motivo de cancelación
                  </Typography>
                  <Typography variant="body2">{data.canceledReason}</Typography>
                </Stack>
              </Grid>
            )}
            {data.canceledAt && (
              <Grid item xs={12}>
                <Stack
                  justifyContent="flex-start"
                  alignItems="flex-start"
                  textAlign="left"
                >
                  <Typography variant="body2" fontWeight="bold">
                    Fecha de cancelación
                  </Typography>
                  <Typography variant="body2">
                    {canceledAt.toLocaleDateString("es-ES", options)}
                  </Typography>
                </Stack>
              </Grid>
            )}
          </Grid>
        </Grid>
      )}
    </Grid>
  );
}
